import {Box, css, List, ListItem, styled} from '@mui/material';
import {CTAButtonFixed} from 'presentation/components/CTAButtonFixed';
import {StyledFooterContainerProps} from './types';

const StyledFooterContainer = styled(Box)<StyledFooterContainerProps>`
	margin: ${props => (props.$mb ? `auto 0px ${props.$mb}px` : 'auto 0px 32px')};
	padding-top: 40px;

	${({$isTablet}) =>
		$isTablet &&
		css`
			margin: auto 0px 0px;
			& footer {
				margin-inline: 24px;
			}
		`}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

const StyledBox = styled(Box)`
	display: flex;
	flex-direction: column;
	gap: 24px;
	background-color: ${({theme}) => theme.palette.background.paper};
	width: 100%;
	padding: 32px;
	border-radius: 8px;
`;

const StyledList = styled(List)`
	list-style: disc;
	padding: 8px 24px;
`;

const StyledListItem = styled(ListItem)`
	display: list-item;
	list-style-type: inherit;
	color: ${({theme}) => theme.palette.text.primary};
	font-size: 16px;
	font-weight: 600;
	padding: 2px 0;
`;

const CustomCTAButtonFixedAction = styled(CTAButtonFixed.Action)`
	padding: 8px 22px;
	align-self: flex-end;
`;

export {StyledFooterContainer, StyledBox, StyledList, StyledListItem, CustomCTAButtonFixedAction};
